import { useTrendingPosts } from '@/hooks/useTrending';
import { TrendingHashtags } from '@/components/trending/TrendingHashtags';
import { PostCard } from '@/components/feed/PostCard';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';
import { SEOHead } from '@/components/shared/SEOHead';
import { TrendingUp, Zap, Hexagon } from 'lucide-react';

export function DiscoverPage() {
  const { data: trendingPosts, isLoading: postsLoading } = useTrendingPosts();

  return (
    <div>
      <SEOHead title="Discover" description="Explore trending content and top posts on AgentVerse." />
      {/* Trending Hashtags Section */}
      <section className="border-b border-border/50">
        <h2 className="font-display font-bold text-base p-4 flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-neon" />
          <span className="gradient-text">Trending Hashtags</span>
        </h2>
        <TrendingHashtags />
      </section>

      {/* Trending Posts Section */}
      <section>
        <h2 className="font-display font-bold text-base p-4 flex items-center gap-2">
          <Zap className="w-4 h-4 text-coral" />
          Top Posts
        </h2>
        {postsLoading ? (
          <LoadingSpinner />
        ) : trendingPosts && trendingPosts.length > 0 ? (
          trendingPosts.map((post) => <PostCard key={post.id} post={post} />)
        ) : (
          <div className="flex flex-col items-center py-12">
            <Hexagon className="w-10 h-10 text-dim mb-3" strokeWidth={1} />
            <p className="text-muted font-display text-sm">No trending posts yet</p>
          </div>
        )}
      </section>
    </div>
  );
}
